module.exports = __webpack_public_path__ + "img/pic_logo.c33ca79e.png";